<template>
<div class="chapter">
<div class="inner_page">
<div class="partbg">
<h2 class="pn"><a id="page_12"></a><a id="page_13"></a><span class="bold">PART ONE</span></h2>
<h2 class="pt"><span class="bold">THE SECRET WAR BEGINS</span></h2>
<p class="chtoc"><a class="yclr" href="#/xhtml/09_Chapter1"><span class="bold">Chapter 1: COLBY’S COVERT WAR</span></a></p>
<p class="chtoc"><a class="yclr" href="#/xhtml/10_Chapter2"><span class="bold">Chapter 2: SWITCHING BACK—SOG IS BORN</span></a></p>
<p class="chtoc"><a class="yclr" href="#/xhtml/11_Chapter3"><span class="bold">Chapter 3: SHINING BRASS</span></a></p>
</div>
<div class="img_container">
<img alt="Images" src="images/f0012-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part1.vue?57700065